import { median } from '#public-research/utils/pr.utils'
import { useQuery } from '@pinia/colada'

export function useMedianLaunchFdv() {
  const query = useQuery({
    ...buildApiQuerySSRSafe('/public-research/fdv-vs-initial-circ-supply', {
      params: () => ({ query: {} }),
    }),
    refetchOnWindowFocus: false,
  })

  const medianFdv = computed(() =>
    median((query.data.value?.linearScale?.tokens ?? []).map(t => t.fdv)),
  )

  return { medianFdv, isLoading: query.isLoading }
}
